import { apiInterfaceForJson, apiInterfaceForFormData } from '../common/apiManager';

// Upload result document for record keeping
export const uploadResultDocument = (formData) => {
    return apiInterfaceForFormData('/resultImport/v1/uploadDocument', 'POST', formData);
};

// Import result document - parse and validate
export const importResultDocument = (data) => {
    return apiInterfaceForJson('/resultImport/v1/import', 'POST', data);
};

// Process and save results to database
export const processResults = (data) => {
    return apiInterfaceForJson('/resultImport/v1/process', 'POST', data);
};

// Process and save results to database
export const manualResult = (data) => {
    return apiInterfaceForJson('/resultImport/v1/manual_result', 'POST', data);
};

// Get import history
export const getImportHistory = (params) => {
    return apiInterfaceForJson('/resultImport/v1/history', 'GET', params);
};

// Get import status
export const getImportStatus = (importId) => {
    return apiInterfaceForJson(`/resultImport/v1/status/${importId}`, 'GET');
};
